import React from 'react';
import styled, { useTheme } from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';

// Styled component for the SVG container
const SVGContainer = styled.div`
  width: ${(props) => props.size || '120px'};
  height: ${(props) => props.size || '120px'};
  @media ${PHONE_MEDIA_QUERY} {
    width: ${'80px'};
    height: ${'80px'};
  }
`;

/**
 * SuccessCircle component - displays a circular success indicator with a checkmark
 *
 * @param {Object} props
 * @param {string} props.size - Size of the success circle (e.g., '120px', '80px')
 * @param {string} props.className - Additional CSS classes
 */
const SuccessCircle = ({ size = '120px', className }) => {
  const theme = useTheme();

  return (
    <SVGContainer size={size} className={className}>
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 120 120'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60ZM6 60C6 89.8234 30.1766 114 60 114C89.8234 114 114 89.8234 114 60C114 30.1766 89.8234 6 60 6C30.1766 6 6 30.1766 6 60Z'
          fill={theme.background.light}
        />
        <path
          d='M120 60C120 93.1371 93.1371 120 60 120C26.8629 120 0 93.1371 0 60C0 26.8629 26.8629 0 60 0C93.1371 0 120 26.8629 120 60ZM6 60C6 89.8234 30.1766 114 60 114C89.8234 114 114 89.8234 114 60C114 30.1766 89.8234 6 60 6C30.1766 6 6 30.1766 6 60Z'
          fill={theme.status.success.primary}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M60 70.5C65.799 70.5 70.5 65.799 70.5 60C70.5 54.201 65.799 49.5 60 49.5C54.201 49.5 49.5 54.201 49.5 60C49.5 65.799 54.201 70.5 60 70.5ZM60 69C64.9706 69 69 64.9706 69 60C69 55.0294 64.9706 51 60 51C55.0294 51 51 55.0294 51 60C51 64.9706 55.0294 69 60 69Z'
          fill={theme.status.success.primary}
        />
        <path
          d='M55.0071 59.7929C54.7143 60.0858 54.7142 60.5607 55.0071 60.8536L58.1891 64.0355C58.482 64.3284 58.9569 64.3284 59.2498 64.0355L65.6137 57.6716C65.9066 57.3787 65.9066 56.9038 65.6137 56.6109C65.3208 56.318 64.846 56.318 64.5531 56.6109L58.7194 62.4445L56.0678 59.7929C55.7749 59.5 55.3 59.5 55.0071 59.7929Z'
          fill={theme.status.success.primary}
        />
      </svg>
    </SVGContainer>
  );
};

export default SuccessCircle;
